module.exports = {"master":{"setings":"การตั้งค่า"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/master.json
// module id = 553
// module chunks = 14